"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoDiv = void 0;
var icons_1 = require("@ant-design/icons");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("../../../..");
var useBoolean_1 = __importDefault(require("../../../../hooks/useBoolean"));
var DetailTlumocnikaPage_1 = require("../../../../pages/DetailTlumocnikaPage");
var Button_1 = __importDefault(require("../../../Button/Button"));
var LinkButton_1 = __importDefault(require("../../../Button/LinkButton"));
var Padder_1 = require("../../../Padder");
var Popup_1 = __importDefault(require("../../../Popup/Popup"));
var Field_1 = __importDefault(require("../../components/Field"));
var Label_1 = __importDefault(require("../../components/Label"));
var Form_1 = __importDefault(require("../../Form"));
var TextAreaField_1 = __importDefault(require("../TextAreaField"));
var AddressResult_1 = __importDefault(require("./components/AddressResult"));
var SelectTypAdresy_1 = __importDefault(require("./components/SelectTypAdresy"));
var validation_1 = require("./validation");
var BorderDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var $hasError = _a.$hasError;
    return $hasError && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: 50px;\n      padding-top: 12px;\n      padding-left: 2px;\n    "], ["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: 50px;\n      padding-top: 12px;\n      padding-left: 2px;\n    "])));
});
exports.InfoDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 13px 36px 10px 20px;\n  font-size: 15px;\n  line-height: 160%;\n  letter-spacing: 0.0125em;\n  margin-bottom: 25px;\n  background-color: #e5ebf0;\n  border-left: 4px solid #2362a2;\n  display: flex;\n  color: #3b3b3b;\n"], ["\n  padding: 13px 36px 10px 20px;\n  font-size: 15px;\n  line-height: 160%;\n  letter-spacing: 0.0125em;\n  margin-bottom: 25px;\n  background-color: #e5ebf0;\n  border-left: 4px solid #2362a2;\n  display: flex;\n  color: #3b3b3b;\n"])));
var PopupChildren = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow: auto;\n  max-height: 90vh;\n"], ["\n  overflow: auto;\n  max-height: 90vh;\n"])));
var CenteredDiv = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"])));
var StyledFontAwesomeIcon = styled_components_1.default(react_fontawesome_1.FontAwesomeIcon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var StyledCloseButton = styled_components_1.default(icons_1.CloseCircleFilled)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: #005285;\n  margin-left: 10px;\n  display: flex;\n  align-self: baseline;\n  font-size: 16px;\n"], ["\n  color: #005285;\n  margin-left: 10px;\n  display: flex;\n  align-self: baseline;\n  font-size: 16px;\n"])));
var MarginLeft = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-left: 5px;\n  display: flex;\n  align-self: stretch;\n"], ["\n  margin-left: 5px;\n  display: flex;\n  align-self: stretch;\n"])));
var ZahranicniAdresaField = function (_a) {
    var _b;
    var name = _a.name, label = _a.label, _c = _a.isSidlo, isSidlo = _c === void 0 ? false : _c;
    var _d = formik_1.useField(name), field = _d[0], meta = _d[1], helpers = _d[2];
    var isOpen = useBoolean_1.default(false);
    var handleSubmit = function (formResult, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                formikHelpers.setStatus(undefined);
                if (!formResult.adresaText && !formResult.typAdresy) {
                    isOpen.setFalse();
                    return [2 /*return*/];
                }
                helpers.setValue(__assign({}, formResult));
                isOpen.setFalse();
                return [2 /*return*/];
            }
            catch (e) {
                formikHelpers.setStatus({ type: 'error', message: e.message });
            }
            return [2 /*return*/];
        });
    }); };
    var handleDeleteAdresy = function () {
        helpers.setValue(undefined);
    };
    return (react_1.default.createElement(Field_1.default, null,
        react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(BorderDiv, { "$hasError": !!meta.error && !field.value },
            !field.value && (react_1.default.createElement(LinkButton_1.default, { type: "button", className: "button", onClick: isOpen.toggle }, "P\u0159idat")),
            field.value && (react_1.default.createElement(AddressResult_1.default, null, (_b = field.value) === null || _b === void 0 ? void 0 :
                _b.adresaText,
                react_1.default.createElement(MarginLeft, null,
                    react_1.default.createElement(StyledFontAwesomeIcon, { icon: free_solid_svg_icons_1.faPen, color: "#005285", width: 15, title: "Editovat", onClick: isOpen.toggle }),
                    react_1.default.createElement(StyledCloseButton, { onClick: handleDeleteAdresy })))),
            react_1.default.createElement(Popup_1.default, { open: isOpen.value, onClose: isOpen.setFalse },
                react_1.default.createElement(PopupChildren, null,
                    react_1.default.createElement(Form_1.default, { initialValues: field.value || {}, validate: validation_1.zahranicniFieldValidation(), onSubmit: handleSubmit }, function (_a) {
                        var isSubmitting = _a.isSubmitting;
                        return (react_1.default.createElement(Padder_1.Padder, null,
                            react_1.default.createElement(DetailTlumocnikaPage_1.StyledH2, null, "P\u0159idat zahrani\u010Dn\u00ED adresu"),
                            react_1.default.createElement(exports.InfoDiv, null,
                                react_1.default.createElement(__1.BulbIcon, null),
                                "Vyberte typ zahrani\u010Dn\u00ED adresy a vlo\u017Ete do textov\u00E9ho pole \u00FAdaje adresy."),
                            isSidlo && (react_1.default.createElement(SelectTypAdresy_1.default, { size: "lg", name: "typAdresy", label: "Typ adresy", enableReset: true, filterResult: function (_a) {
                                    var id = _a.id;
                                    return ramda_1.contains(id, [__1.TlumocniciTypAdresy.adresaSidlaZahranicni]);
                                } })),
                            !isSidlo && (react_1.default.createElement(SelectTypAdresy_1.default, { size: "lg", name: "typAdresy", label: "Typ adresy", enableReset: true, filterResult: function (_a) {
                                    var id = _a.id;
                                    return ramda_1.contains(id, [__1.ZnalciTypAdresy.adresaPobytuMimoUzemiCR, __1.ZnalciTypAdresy.adresaTrvalehoPobytuMimoUzemiCR]);
                                } })),
                            react_1.default.createElement(TextAreaField_1.default, { name: "adresaText", label: "Adresa", toolTip: "Vypl\u0148te adresu pobytu v zahrani\u010D\u00ED", maxLength: 250 }),
                            react_1.default.createElement(CenteredDiv, null,
                                react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Overit" }, "Ulo\u017Eit adresu"))));
                    }))))));
};
ZahranicniAdresaField.defaultProps = {
    isSidlo: false,
};
exports.default = ZahranicniAdresaField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
